<div class="access-settings-container" *ngIf="!isLoadingPermissionData && !isLoadingLabels">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'group_permission' }" (click)="selectedTab = 'group_permission'">{{
			labels.lbl_geral_grupo_permissoes
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'permission' }" (click)="selectedTab = 'permission'">{{
			labels.lbl_geral_permissoes
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="selectedTab === 'group_permission'">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_grupo_permissoes }}*</span>
				<select [(ngModel)]="selectedUsertype" (change)="onPermissionChange()">
					<option value="">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let item of usertypeList" [value]="item.usertype">{{ item.usertype }}</option>
				</select>
			</div>

			<div class="dotted-input-container" *ngIf="!isLoadingData && showView">
				<span>{{ labels.lbl_geral_group_permission_creation }}</span>
				<input id="usertype" name="usertype" type="text" [(ngModel)]="usertypeValue" />
			</div>

			<div class="button-container" *ngIf="showView">
				<div class="button" (click)="showViewDiv()">{{ labels.lbl_geral_cancelar }}</div>
				<div class="button" (click)="saveGroupsUsers()">{{ labels.lbl_geral_salvar }}</div>
			</div>

			<div class="button-container" *ngIf="!showView">
				<div class="button" (click)="deleteUsertype()">{{ labels.lbl_geral_excluir }}</div>
				<div class="button" (click)="showViewDiv()">{{ labels.lbl_geral_new_permission_group }}</div>
			</div>
		</ng-container>

		<ng-container *ngIf="selectedTab === 'permission'">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_search_permissions }}</span>
				<input
					type="text"
					[(ngModel)]="searchPermissions"
					[placeholder]="labels.lbl_geral_search_permissions"
					(keyup)="searchPermissionsAll()" />
			</div>

			<div class="table-container">
				<table>
					<thead>
						<tr>
							<th>{{ labels.lbl_cadastro_permissoes }} *</th>
							<th>{{ labels.lbl_geral_descricao }}</th>
							<th>{{ labels.lbl_rep_ordem }}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of permissionsList; let i = index">
							<td>{{ item.permission }}</td>
							<td>{{ item.description }}</td>
							<td>{{ item.group }}</td>
							<td class="cursor">
								<fa-icon
									[icon]="item.toggle === true ? icons.faToggleOn : icons.faToggleOff"
									[class.toggle-on-green]="item.toggle === true"
									(click)="toggleChange(item.permission, i)">
								</fa-icon>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="button-container">
				<div class="button" (click)="managePermissionGroup(selectedUsertype, selectedPermission)">
					{{ labels.lbl_geral_atualizar }}
				</div>
			</div>
		</ng-container>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	*ngIf="isLoadingPermissionData || isLoadingLabels"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
